import { get as _get } from 'lodash-es';
import { UtilsService } from 'homeday-blocks';
import { isTablet, isMobile } from '@/services/breakpoints';
import store from '@/store';
import CONFIG from '@/config/env';

export { default as EVENTS } from '@/config/GTM_EVENTS';

let isLoaded = false;

export function setDataLayerVariables() {
  window.dataLayer = window.dataLayer || [];

  let deviceType = 'desktop';
  if (isTablet()) deviceType = 'tablet';
  if (isMobile()) deviceType = 'mobile';

  const application = _get(CONFIG, 'integrations.gtm.application');

  const variables = {
    environment: {
      country: 'de',
      language: 'de',
      device_type: deviceType,
      application,
      network_status: 'online',
    },
  };

  const { uid } = store.state.user.data;

  if (uid) {
    variables.user = {
      uid,
    };
  }

  window.dataLayer.push(variables);
}

export function load() {
  if (isLoaded) {
    return;
  }

  const id = _get(CONFIG, 'integrations.gtm.id');

  if (!id) {
    return;
  }

  UtilsService.loadScript({
    url: `https://www.googletagmanager.com/gtm.js?id=${id}`,
    head: true,
    first: true,
  });

  // We populate the dataLayer
  setDataLayerVariables();

  window.dataLayer.push({
    'gtm.start': new Date().getTime(),
    event: 'gtm.js',
  });

  isLoaded = true;
}

export function gtag() {
  // gtag expects Arguments and not just a normal array of params, so spread operator doesn't work
  // eslint-disable-next-line prefer-rest-params
  window.dataLayer.push(arguments);
}

export function sendPageView() {
  if (!isLoaded) {
    return;
  }

  window.dataLayer.push({ event: 'virtualPageview' });
}

export function sendEvent({
  category = '',
  action = '',
  label = '',
  value = '',
  nonInteraction = false,
}) {
  if (!isLoaded) {
    return;
  }

  window.dataLayer.push({
    eventCategory: category,
    eventAction: action,
    eventLabel: label,
    eventValue: value,
    eventNonInteraction: nonInteraction,
    event: 'gtmEvent',
  });
}

// We update the datalayer variables on user
store.watch((state) => state.user.data.uid, setDataLayerVariables);
